var _path, _path2, _path3, _path4, _path5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTokenStandardsLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M24.4925 31.5444L37 24.0456L24.4925 18.2879L12 24.0456L24.4925 31.5444Z",
    fill: "url(#paint0_linear_1031_6339)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M24.4925 18.2877V3L12 24.0453L24.4925 31.5441V18.2877Z",
    fill: "url(#paint1_linear_1031_6339)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M24.4885 31.5441L36.996 24.0453L24.4885 2.99999V18.2876V31.5441Z",
    fill: "url(#paint2_linear_1031_6339)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M24.4925 33.9406L12 26.4572L24.4925 44.3258V33.9406Z",
    fill: "url(#paint3_linear_1031_6339)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M36.996 26.4572L24.4885 33.9406V44.3258L36.996 26.4572Z",
    fill: "url(#paint4_linear_1031_6339)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1031_6339",
    x1: 1941,
    y1: 1651.88,
    x2: 5631.16,
    y2: 2016.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C8BDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F37D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1031_6339",
    x1: 975.919,
    y1: 3520.49,
    x2: 2836.92,
    y2: 3563.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C8BDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F37D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1031_6339",
    x1: 989.569,
    y1: 3520.49,
    x2: 2852.81,
    y2: 3563.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C8BDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F37D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1031_6339",
    x1: 975.919,
    y1: 2228.41,
    x2: 2835.4,
    y2: 2296.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C8BDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F37D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1031_6339",
    x1: 989.569,
    y1: 2228.41,
    x2: 2851.29,
    y2: 2296.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C8BDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F37D2"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTokenStandardsLogo);
export default __webpack_public_path__ + "static/media/tokenStandardsLogo.a852f5a61473f87722c64a7b90f0ca21.svg";
export { ForwardRef as ReactComponent };